import type {
  TableCommandFactory,
  TableRowIdValue,
} from 'components/Table/model/TableModel';

type SetSelectedRowsCommand = {
  rowIds: TableRowIdValue[];
};

/**
 * Fully override current set of selected rows with a new set.
 */
export const setSelectedRows: TableCommandFactory<SetSelectedRowsCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.selectedRows = new Set(command.rowIds);
      draft.allRowsSelectState = 'unchecked';
    });
  };
